import {forwardRef} from 'react';

import {view} from '@sail/ui';

import type {
  Conversation,
  ConversationLogItem,
} from '@stripe-internal/conversations-client';

import {
  DotComChatBubbleAnimationContext,
  useItemsDotCom,
} from './useItemsDotCom';
import {renderItemsGroupedV1} from './renderItemsGroupedV1';

type Props = {
  conversation: Conversation;
  items: ConversationLogItem[];
  animated?: boolean;
  disableInteraction?: boolean;
};

export const DotComLogItems = forwardRef<HTMLDivElement, Props>(
  ({conversation, items, animated, disableInteraction}, ref) => {
    const dotComItems = useItemsDotCom(conversation, items);

    const rows = renderItemsGroupedV1(conversation, dotComItems.items, {
      animated,
      disableInteraction,
    });

    return (
      <view.div
        ref={ref}
        data-testid="conversation-log-items"
        css={{
          display: 'flex',
          flexDirection: 'column',
          gap: 'medium',
        }}
      >
        <DotComChatBubbleAnimationContext.Provider
          value={dotComItems.contextValue}
        >
          {rows}
        </DotComChatBubbleAnimationContext.Provider>
      </view.div>
    );
  },
);
